const buttonProperties = {
  medicalTreatment: {
    icon: "icon-critical-illness",
    title: "medical treatment",
    description:
      "Claim for treatment from your plan. Please note, this doesn't include cash benefit."
  },
  inPatientNHS: {
    icon: "icon-health-kit",
    title: "In-patient NHS",
    description:
      "Claim for each night you have received free treatment under the NHS."
  },
  dentalOrOptical: {
    icon: "icon-people-man",
    title: "dental or optical",
    description: "Claim for dental or optical treatment you have had."
  },
  privateGPFees: {
    icon: "icon-stethoscope-outline",
    title: "Private GP fees",
    description: "Claim for private GP fees."
  },
  chiropodyPodiatry: {
    icon: "icon-people-woman",
    title: "chiropody and podiatry",
    description: "Claim for chiropody and podiatry treatment."
  },
  childbirth: {
    icon: "icon-hospital-outline",
    title: "Childbirth",
    description: "Claim for childbirth - this is payable for each birth."
  },
  nhsChemoOrRadio: {
    icon: "icon-hospital-bed-outline",
    title: "nhs chemotherapy or radiotherapy",
    description:
      "Claim for in-patient or out-patient radiotherapy or chemotherapy."
  }
};

const ClaimBackOptions = {
  label: "Now select the treatment you had from the following options",
  tooltip: {
    HOL:
      "Please note: Cash benefit isn’t available on all policies; please ensure you're covered before you make your claim.",
    Any:
      "Please note: Cash benefit isn’t available on all plans; please ensure you're covered before you make your claim."
  },
  buttons: {
    Saga: {
      ...buttonProperties,
      dentalOrOptical: {
        icon: "icon-people-man",
        title: "Dental, Optical and Health screening",
        description:
          "Claim for dental or optical treatment, or health screenings you have had."
      }
    },
    HOL: {
      ...buttonProperties,
      medicalTreatment: {
        icon: "icon-critical-illness",
        title: "medical treatment",
        description:
          "Claim for treatment from your policy. Please note, this doesn't include cash benefit."
      }
    },
    Any: buttonProperties
  },

  cashBenefitStatusLabel: "cash benefit"
};

export default ClaimBackOptions;
